"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.every.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.iterator.reduce.js");
var _rater = require("@/api/rater");
var _user = require("@/api/user");
var _cookie = require("@/utils/cookie");
var _ga = require("@/utils/ga");
var _log = require("@/utils/log");
var _utils = require("@/utils");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _moment = _interopRequireDefault(require("moment"));
var _lodash = _interopRequireDefault(require("lodash"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Report',
  data() {
    return {
      reportType: 'individual',
      raterList: [],
      tenant: '',
      loggedInUserTenants: [],
      yearIso: '2021',
      weekOfYear: '1',
      individualYearIso: '',
      individualWeekOfYear: '',
      allYearIso: '',
      allWeekOfYear: '',
      tasYearIso: '',
      tasWeekOfYear: '',
      rater: '',
      errorMsg: '',
      totalJobs: 0,
      totalVideos: 0,
      totalCompletedJob: 0,
      jobs: [],
      summary: [],
      tasCredit: [],
      loading: false,
      downloadLoading: false,
      firstLoad: true,
      totalTaskCredit: 0
    };
  },
  created() {
    var now = new Date();
    this.getRaterList();
    this.yearIso = (0, _moment.default)(now).isoWeekYear();
    this.weekOfYear = (0, _moment.default)(now).isoWeek().toString();
    if (this.$store.getters.userMetadata && this.$store.getters.userMetadata.tenants) {
      this.loggedInUserTenants = this.$store.getters.userMetadata.tenants;
      if (this.loggedInUserTenants.length > 0) {
        this.tenant = this.loggedInUserTenants[0];
      }
    }
  },
  methods: {
    getTenantLabel: _utils.getTenantLabel,
    yearIsoIsValid() {
      return /^[0-9]+$/.test(this.yearIso); // Check if it is a positive integer
    },
    weekOfYearIsValid() {
      if (this.reportType !== 'tasCreditReport') {
        return /^[0-9]+$/.test(this.weekOfYear); // Check if it is a positive integer
      } else {
        return this.weekOfYear.split(',').map(s => s.trim()).every(s => /^[0-9]+$/.test(s)); // Check if it is a positive integer
      }
    },
    getStartDate(yearIso, weekOfYear) {
      var start = (0, _moment.default)().isoWeekYear(yearIso).isoWeeks(weekOfYear).startOf('isoWeek');
      return start.format('yyyy-MM-DD');
    },
    getEndDate(yearIso, weekOfYear) {
      var end = (0, _moment.default)().isoWeekYear(yearIso).isoWeeks(weekOfYear).endOf('isoWeek');
      return end.format('yyyy-MM-DD');
    },
    getWeekPeriods(yearIso, weekOfYear) {
      let periods = '';
      const weekOfYearISO = weekOfYear.split(',').map(n => Number(n));
      weekOfYearISO.forEach(week => {
        const isoWeek = (0, _moment.default)().isoWeekYear(yearIso).isoWeeks(week);
        periods += isoWeek.startOf('isoWeek').format('yyyy-MM-DD') + ' to ' + isoWeek.endOf('isoWeek').format('yyyy-MM-DD') + ', ';
      });
      return periods.slice(0, -2);
    },
    getRaterList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const query = {
        page: 1,
        limit: 200,
        role: 'otr-rater',
        sort: 'givenName'
      };
      (0, _user.getUserList)(token, query).then(response => {
        // this.list = response.data.items
        this.raterList = response.data.rows.map(s => {
          return {
            uuid: s.uuid,
            name: `${s.givenName} ${s.familyName}`
          };
        });
      }).catch(error => {
        (0, _log.showDebugLog)('GetUserList-api-error', error);
      });
    },
    getUserName(uuid) {
      var staff = this.raterList ? this.raterList.find(u => u.uuid === uuid) : null;
      return staff ? staff.name : '-';
    },
    checkHasOverallScore(userContent) {
      var overallStatus;
      if (userContent.length > 0) {
        overallStatus = userContent[0].hasOverallScore ? 'Yes' : 'No';
      } else {
        overallStatus = '-';
      }
      return overallStatus;
    },
    generateReport() {
      if (this.reportType === 'individual' && this.rater === '') {
        (0, _log.displayPopupMessage)('Please select rater.', 'error');
        return;
      }
      if (!this.yearIsoIsValid()) {
        (0, _log.displayPopupMessage)('Please fill in a valid Year(ISO).', 'error');
        return;
      }
      if (!this.weekOfYearIsValid()) {
        (0, _log.displayPopupMessage)('Please fill in a valid Week of Year.', 'error');
        return;
      }
      this.errorMsg = '';
      if (this.reportType === 'individual') {
        this.individualYearIso = this.yearIso;
        this.individualWeekOfYear = this.weekOfYear;
        this.individualReport();
      }
      if (this.reportType === 'all') {
        this.allYearIso = this.yearIso;
        this.allWeekOfYear = this.weekOfYear;
        this.summaryReport();
      }
      if (this.reportType === 'tasCreditReport') {
        this.tasYearIso = this.yearIso;
        this.tasWeekOfYear = this.weekOfYear;
        this.tasCreditReport();
      }
    },
    individualReport() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      const reqTenant = this.tenant === 'all' ? undefined : this.tenant;
      (0, _rater.generateIndividualReport)(token, this.yearIso, this.weekOfYear, this.rater, reqTenant).then(response => {
        this.totalJobs = response.data.count;
        this.jobs = response.data.rows;
        var totalvideos = 0;
        var totalCompletedJob = 0;
        var totaltaskCredit = 0;
        _lodash.default.forEach(this.jobs, function (j) {
          totalvideos += j.userContents.length;
          totaltaskCredit += j.raterTaskCredit;
          if (j.jobStatus === 'complete') totalCompletedJob += 1;
        });
        this.totalVideos = totalvideos;
        this.totalCompletedJob = totalCompletedJob;
        this.totalTaskCredit = totaltaskCredit;
        this.loading = false;
        this.firstLoad = false;
        // console.log(response.data)
        // console.log('Done')
      }).catch(error => {
        this.loading = false;
        (0, _log.showDebugLog)('Update Fail:', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    summaryReport() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      const reqTenant = this.tenant === 'all' ? undefined : this.tenant;
      (0, _rater.generateSummaryReport)(token, this.yearIso, this.weekOfYear, reqTenant).then(response => {
        var totalVideos = 0;
        var totalJobs = 0;
        var totalCompletedJob = 0;
        var raters = response.data.raters;
        var jobs = response.data.rows;
        this.summary = [];
        for (var i = 0; i < raters.length; i++) {
          var raterTotalJobs = 0;
          var raterTotalCompleteJobs = 0;
          var raterTotalvideos = 0;
          var raterName = this.getUserName(raters[i]);
          for (var j = 0; j < jobs.length; j++) {
            console.log('job Detail', jobs[j]);
            if (jobs[j].rater === raters[i]) {
              totalJobs += 1;
              totalVideos += jobs[j].userContents.length;
              raterTotalJobs += 1;
              raterTotalvideos += jobs[j].userContents.length;
              if (jobs[j].jobStatus === 'complete') {
                raterTotalCompleteJobs += 1;
              }
            }
          }
          totalCompletedJob += raterTotalCompleteJobs;
          this.summary.push({
            rater: raterName,
            raterUuid: raters[i],
            totalJob: raterTotalJobs,
            totalCompleteJob: raterTotalCompleteJobs,
            totalVideo: raterTotalvideos
          });
        }
        this.totalCompletedJob = totalCompletedJob;
        this.totalJobs = totalJobs;
        this.totalVideos = totalVideos;
        this.loading = false;
        this.firstLoad = false;
        // console.log('partition', this.summary)
        // console.log('Done')
      }).catch(error => {
        this.loading = false;
        (0, _log.showDebugLog)('Update Fail:', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    tasCreditReport() {
      this.loading = true;
      this.generateTASCreditReport().then(response => {
        const tasCredit = response.data.raters.map(rater => {
          const raterReports = response.data.rows.filter(row => row.rater === rater);
          return {
            rater: this.getUserName(rater),
            raterUuid: rater,
            benchmarks: raterReports.filter(row => row.stageType === 'benchmark').length,
            summits: raterReports.filter(row => row.stageType === 'summit').length,
            totalCredits: raterReports.reduce((previousValue, currentRow) => previousValue + currentRow.raterTaskCredit, 0)
          };
        });
        this.tasCredit = tasCredit;
        this.loading = false;
        this.firstLoad = false;
      }).catch(error => {
        this.loading = false;
        (0, _log.showDebugLog)('Update Fail:', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    generateTASCreditReport() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const weekOfYearISO = this.weekOfYear.split(',').map(n => Number(n)).filter(n => {
        return !isNaN(n) && n % 1 === 0; // not NaN & decimal
      });
      const reqTenant = this.tenant === 'all' ? undefined : this.tenant;
      return (0, _rater.generateTASCreditReport)(token, {
        year: this.yearIso,
        weekOfYearISO
      }, reqTenant);
    },
    releaseRaterJob(raterId, jobId, userHikeId, stageId) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const email = (0, _cookie.getCookie)('EMAIL');
      this.loading = true;
      (0, _rater.releaseJob)(token, raterId, jobId, userHikeId, stageId).then(response => {
        this.loading = false;
        (0, _ga.writeGaEvent)(this, 'RaterAssignment', `${_lifehikesInitData.userEvent.raterAssignment.release}`, email, `Release Job - raterId: ${raterId}, jobId: ${jobId}, userHikeId: ${userHikeId}, stageId: ${stageId}`);
        this.generateReport();
      }).catch(error => {
        this.loading = false;
        (0, _log.showDebugLog)(error);
        (0, _log.displayPopupMessage)('Fail to release the task', 'error');
      });
    },
    handleTabChange(val) {
      console.log(val);
    },
    cssWordRed(val) {
      if (val === 'open') {
        return {
          open: true,
          complete: false
        };
      } else {
        return {
          open: false,
          complete: true
        };
      }
    },
    handleDownload() {
      this.downloadLoading = true;
      this.generateTASCreditReport().then(response => {
        const tasCredit = response.data.raters.map(rater => {
          const raterReports = response.data.rows.filter(row => row.rater === rater);
          return {
            rater: this.getUserName(rater),
            raterUuid: rater,
            benchmarks: raterReports.filter(row => row.stageType === 'benchmark').length,
            summits: raterReports.filter(row => row.stageType === 'summit').length,
            totalCredits: raterReports.reduce((previousValue, currentRow) => previousValue + currentRow.raterTaskCredit, 0)
          };
        });
        Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'))).then(excel => {
          const xdata = this.buildExcelData(tasCredit);
          excel.export_json_to_excel({
            header: xdata.header,
            data: xdata.data,
            filename: 'Training Assessment Scorer Report'
          });
          this.downloadLoading = false;
        });
      }).catch(error => {
        this.downloadLoading = false;
        (0, _log.showDebugLog)('Update Fail:', error);
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    buildExcelData(tasCredit) {
      const excelHeader = ['Training Assessment Scorer Report', '', '', '', '']; // header row
      const excelData = [];
      excelData.push(['Year', this.yearIso, '', '', '']);
      excelData.push(['Range Date', this.weekOfYear + '(' + this.getWeekPeriods(this.yearIso, this.weekOfYear) + ')', '', '', '']);
      excelData.push(['', '', '', '', '']);
      excelData.push(['', '', '', '', '']);
      excelData.push(['', 'Benchmarks', 'Summits', 'Total Credits', 'Total $']);

      // build data row
      for (let i = 0, l = tasCredit.length; i < l; i++) {
        const row = [];
        row.push(tasCredit[i].rater + '(' + tasCredit[i].raterUuid + ')');
        row.push(tasCredit[i].benchmarks);
        row.push(tasCredit[i].summits);
        row.push(tasCredit[i].totalCredits);
        row.push('');
        excelData.push(row);
      }
      return {
        data: excelData,
        header: excelHeader
      };
    }
  }
};